// extracted by mini-css-extract-plugin
export default {"pagination":"page_pagination__AHfkU","page-link":"page_page-link__6-ZFY","positiveTrend":"page_positiveTrend__n288c","negativeTrend":"page_negativeTrend__qf1mT"};